<template>
  <div class="bg-container">
    <div class="login">
      <div class="hero">
        <div class="head">
          <van-popover
            v-model="showPopover"
            trigger="click"
            placement="bottom"
            :offset="[0, 8]"
            :actions="actions"
            @select="onSelect"
          >
            <template #reference>
              <van-button type="primary" plain>{{languageText}}</van-button>
            </template>
          </van-popover>
        </div>
        <div class="logo">
          <img src="/img/login/logo2.png?v=2" alt="">
        </div>
      </div>
      <div class="sheet">
        <div class="wrap">
          <div class="input_wrap">
            <van-icon name="contact-o" size="16" color="#b79cec"></van-icon>
            <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
          </div>
          <div class="input_wrap">
            <img src="/img/login/password.png" alt="" style="width: 1.00rem; height: 1.00rem;">
            <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
            <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#b79cec" size="24" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
          </div>
        </div>
        <div class="button" @click="doLogin()">{{$t("auth.login")}}</div>
        <div class="row" @click="toRegister">{{$t("auth.no_account")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { LANGS, langName, setLangManual } from "@/common/languages";
import { connectWs } from "@/common/ws";
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pwdType: 1,
      username: "",
      lang: localStorage.getItem("lang") || "en_us",
      password: this.inputValue,
      passwordType: "password",
      showPopover: false,
      actions: LANGS.map(item => ({
        text: item.name,
        code: item.code,
        className: 'login-lang-action',
      })),
    };
  },
  computed: {
    languageText() {
      return langName(this.$i18n.locale || this.lang);
    },
  },
  mounted() {
    this.syncLangDisplay();
  },
  activated() {
    this.syncLangDisplay();
  },
  methods: {
    syncLangDisplay() {
      const saved = localStorage.getItem("lang") || this.$i18n.locale || "en_us";
      this.lang = saved;
      if (this.$i18n.locale !== saved) {
        this.$i18n.locale = saved;
      }
    },
    onSelect(e) {
      Toast.loading({
        duration: 200,
      });
      // 用 LANGS 反查，避免 popover 丢自定义 code 字段
      const hit = LANGS.find(item => item.code === e.code || item.name === e.text);
      const code = hit ? hit.code : (e.code || "en_us");
      this.lang = code;
      this.$i18n.locale = code;
      localStorage.setItem("lang", code);
      setLangManual();  // 手动选择优先，之后不再被 IP / 注册地区覆盖
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: { 
          username: this.username, 
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          connectWs(); // 登录成功后建立全局 WS
          this.$applyLoginLang(res.data.reg_lang); // 登录后按注册地区语言切换
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.bg-container {
  background: @bg-soft;
  height: 100%;
}
.login {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: @bg-soft;
}

.hero {
  position: relative;
  flex-shrink: 0;
  height: 16.5rem;
  background:
    linear-gradient(180deg, rgba(74, 40, 90, 0.05) 40%, rgba(255, 214, 228, 0.28) 100%),
    url('/public/img/login/bg2.png') no-repeat center top / cover;
  border-radius: 0 0 2.4rem 2.4rem;
}

.logo {
  position: absolute;
  left: 1.2rem;
  bottom: 2.2rem;
  width: 16.8rem;
  max-width: calc(100% - 2.4rem);
  img{
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1462 / 482;
    border-radius: 0.45rem;
    filter: drop-shadow(0 0.25rem 0.6rem rgba(80, 40, 90, 0.35));
  }
}

.sheet {
  position: relative;
  z-index: 2;
  flex: 1;
  margin-top: -1.8rem;
  padding: 4.5rem 1.35rem 1.6rem;
  background: #fffafc;
  border-radius: 1.8rem 1.8rem 0 0;
  box-shadow: 0 -0.45rem 1.4rem rgba(183, 156, 236, 0.18);
}

.wrap{
  .input_wrap{
    width: 100%;
    height: 3.2rem;
    margin: 0 0 0.75rem;
    border-radius: 0.9rem;
    overflow: hidden;
    background: #fff;
    border: 1px solid #f0e2f2;
    box-shadow: 0 0.15rem 0.5rem rgba(183, 156, 236, 0.08);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 1rem;
    input{
      flex: 1;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      text-align: left;
      font-size: .93333rem;
      padding-left: 0.75rem;
      color: @text-title;
      &::placeholder {
        color: @text-sub;
      }
    }
  }
}

.row {
  font-size: 0.92rem;
  color: #8a63c9;
  font-weight: 500;
  margin: 1rem 0 0;
  text-align: left;
}

.button{
  width: 100%;
  background: @grad-primary;
  box-shadow: @shadow-pink;
  font-size: 1.08rem;
  font-weight: 600;
  letter-spacing: 0.06rem;
  color: #fff;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  border-radius: 0.9rem;
  margin: 0.55rem 0 0;
}
.head{
  padding: 0.9rem 0.75rem;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
/* 防止 flex 把 wrapper 撑宽，导致下拉相对按钮歪掉 */
.head ::v-deep .van-popover__wrapper {
  display: inline-flex !important;
  flex: none;
  width: auto !important;
  max-width: max-content;
}
.van-button {
  height: 1.9rem;
  line-height: 1.9rem;
  padding: 0 0.9rem;
  font-size: 0.88rem;
  background: rgba(255, 255, 255, 0.72);
  border-color: rgba(255, 255, 255, 0.9);
  color: @text-title;
  border-radius: @radius-pill;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>

<style lang="less">
/* PC 兼容：Vant action 的 px→vw 在宽屏会被拉高，统一用 rem 覆盖 */
.van-popover__content:has(.login-lang-action) {
  max-height: 16rem;
  overflow-x: hidden;
  overflow-y: auto;
}
/* 箭头居中对准按钮，避免 px→vw 把箭头顶歪 */
.van-popover:has(.login-lang-action) .van-popover__arrow {
  border-width: 0.375rem !important;
}
.van-popover[data-popper-placement^='bottom']:has(.login-lang-action) .van-popover__arrow {
  left: 50% !important;
  right: auto !important;
  top: 0 !important;
  transform: translate(-50%, -100%) !important;
}
.login-lang-action.van-popover__action {
  width: 5.5rem !important;
  min-width: 5.5rem !important;
  height: 1.75rem !important;
  padding: 0 0.75rem !important;
  font-size: 0.625rem !important; /* 10px */
  line-height: 1.75rem !important;
  box-sizing: border-box;
}
.login-lang-action .van-popover__action-text {
  font-size: 0.625rem !important; /* 10px */
  line-height: 1.75rem !important;
  height: 100% !important;
}
</style>
